import { DatePicker, Dropdown, IDropdownOption } from "@fluentui/react";
import React, { useContext } from "react";
import { formatDate } from "../utils/date";
import { capitalize } from "../utils/text";
import { ColumnOptionsContext } from "./ColumnOptions";
import {
  Column,
  DateFilter as DateFilterType,
  DateFilterOperator,
  dateFilterOperators,
} from "./types";

type Props = {
  column: Column;
};

export const DateFilter = ({ column }: Props) => {
  const filter = column.filter as DateFilterType;
  const { setFilter, strings, filterProps, id } =
    useContext(ColumnOptionsContext);

  let date1Props: any = filterProps
    ? filterProps[column.key]
      ? filterProps[column.key].date1
      : undefined
    : undefined;

  let date2Props: any = undefined;

  if (filter.operator === "isBetween") {
    date1Props = {
      ...(date1Props || {}),
      maxDate: filter.date2 ?? (date1Props ? date1Props.maxDate : undefined),
    };
    date2Props = filterProps
      ? filterProps[column.key]
        ? filterProps[column.key].date2
        : undefined
      : undefined;
    date2Props = {
      ...(date2Props || {}),
      minDate: filter.date1 ?? (date2Props ? date2Props.minDate : undefined),
    };
  }

  const options: IDropdownOption[] = dateFilterOperators.map((o) => ({
    key: o,
    text: strings[`dateFilterOperator${capitalize(o)}Label`],
  }));

  return (
    <div>
      <Dropdown
        selectedKey={filter.operator}
        options={options}
        id={id ? `${id}-DateFilter-${column.key}` : undefined}
        onChange={(_, option) => {
          if (!option) return;
          setFilter(column.key, {
            ...column.filter,
            operator: option.key as DateFilterOperator,
          } as DateFilterType);
        }}
        styles={{ root: { marginBottom: 4 } }}
      />
      <DatePicker
        value={filter.date1 ?? undefined}
        onSelectDate={(date) => {
          setFilter(column.key, {
            ...column.filter,
            date1: date ?? null,
          } as DateFilterType);
        }}
        formatDate={(date) => (date ? formatDate(date) : "")}
        {...date1Props}
        styles={{ root: { marginBottom: 4 } }}
        strings={strings.datePickerStrings}
      />
      {filter.operator === "isBetween" && (
        <DatePicker
          value={filter.date2 ?? undefined}
          id={id ? `${id}-DatePicker-${column.key}` : undefined}
          onSelectDate={(date) => {
            setFilter(column.key, {
              ...column.filter,
              date2: date ?? null,
            } as DateFilterType);
          }}
          formatDate={(date) => (date ? formatDate(date) : "")}
          {...date2Props}
          strings={strings.datePickerStrings}
        />
      )}
    </div>
  );
};
